import React, { useRef } from "react";
import { Input, Dropdown, Button, message } from "antd";
import { DownOutlined } from "@ant-design/icons";

const MAX_LENGTH = 30;

// Phải khớp TransferContent::VARIABLES ở backend — biến lạ sẽ bị từ chối khi lưu.
const VARIABLES = [
  { key: "tai_san", label: "Tài sản (mã căn)" },
  { key: "ma_khach_hang", label: "Mã khách hàng" },
  { key: "ten_khach_hang", label: "Tên khách hàng" },
  { key: "ma_code", label: "Mã phiếu thu" },
  { key: "duong_dia_chi_tai_san", label: "Đường / địa chỉ tài sản" },
  { key: "chi_tiet_tai_san", label: "Chi tiết tài sản" },
];

/**
 * Ô "Nội dung chuyển khoản" có nút chèn biến tại vị trí con trỏ.
 * Dùng trong Form.Item: nhận value/onChange do Form truyền vào.
 */
const TransferContentInput = ({ value, onChange, disabled }) => {
  const inputRef = useRef(null);

  const insertVariable = ({ key }) => {
    const token = `{${key}}`;
    const current = value || "";
    const el = inputRef.current?.input;
    const start = el?.selectionStart ?? current.length;
    const end = el?.selectionEnd ?? current.length;
    const next = current.slice(0, start) + token + current.slice(end);

    if (next.length > MAX_LENGTH) {
      message.warning(`Nội dung chuyển khoản tối đa ${MAX_LENGTH} ký tự`);
      return;
    }

    onChange?.(next);
    requestAnimationFrame(() => {
      const caret = start + token.length;
      el?.focus();
      el?.setSelectionRange(caret, caret);
    });
  };

  const menuItems = VARIABLES.map(({ key, label }) => ({
    key,
    label: (
      <div className="flex justify-between gap-4">
        <span>{label}</span>
        <span className="text-ink-400">{`{${key}}`}</span>
      </div>
    ),
  }));

  return (
    <>
      <Input
        ref={inputRef}
        value={value}
        onChange={onChange}
        placeholder="Ví dụ: DONG TIEN THANG 4 hoặc {tai_san} TT PDV"
        maxLength={MAX_LENGTH}
        showCount
        disabled={disabled}
        className="rounded-lg"
        addonAfter={
          <Dropdown
            menu={{ items: menuItems, onClick: insertVariable }}
            trigger={["click"]}
            disabled={disabled}
          >
            <Button type="text" size="small" disabled={disabled}>
              Chèn biến <DownOutlined />
            </Button>
          </Dropdown>
        }
      />
      <div className="mt-1 text-xs text-ink-500">
        Biến được thay theo từng khoản thu, ví dụ {"{tai_san} TT PDV"} → H22905 TT PDV.
        Chỉ áp dụng cho tài khoản VCB / BIDV / MB.
      </div>
    </>
  );
};

export default TransferContentInput;
